import { getUltimaVersionLaridae } from '../../../../../models/tools/getUltimaVersionLaridae/laridae';

export type IUpdateVersionLaridaeAction = { type: 'UPDATE_VERSION_LARIDAE_PARA_PDF', versionLaridae: string }

export const getVersionLaridae = ()=>async(dispatch: (action:any)=>void)=> dispatch({
  type: 'UPDATE_VERSION_LARIDAE_PARA_PDF',
  versionLaridae: await getUltimaVersionLaridae()
})